import React, { useCallback, useMemo } from "react";
import { VideoDeviceInfo } from "@azure/communication-calling";
import { DevicePermissionDropdown, DevicePermissionDropdownProps } from "./DevicePermissionsDropdown";
import { ConfigurationPageDeviceDropdown } from "./ConfigurationPageDeviceDropdown";
import { DeviceSelectionContainer } from "./DeviceSelectionContainer";


const grantedIconName = 'LocalDeviceSettingsCamera';
const notGrantedIconName = 'ControlButtonCameraOff';


interface CameraSelectionProps {
    isMobile: boolean;
    permissionGranted: boolean;

    defaultCamera?: VideoDeviceInfo;
    cameras: VideoDeviceInfo[];
    selectedCamera?: VideoDeviceInfo;
    onSelectCamera: (microphone: VideoDeviceInfo) => void;

    roleCanUseCamera: boolean;

    dropdownProps: Partial<DevicePermissionDropdownProps>;
    onClickEnableDevicePermission?: () => void;
}

export const CameraSelection = (props: CameraSelectionProps): JSX.Element => {
    const {
        permissionGranted,
        onSelectCamera,
        cameras,
    } = props;

    const iconName = useMemo(
        () => (permissionGranted ? grantedIconName : notGrantedIconName),
        [permissionGranted]
    );

    const onSelectMicrophoneCb = useCallback((deviceId: string) => {
        const mic = cameras.find(s => s.id === deviceId);
        onSelectCamera(mic!);
    }, [onSelectCamera, cameras]);

    const micGrantedDropdown = (
        <>
            {props.roleCanUseCamera && (
                <ConfigurationPageDeviceDropdown
                    aria-labelledby={'call-composite-local-sound-settings-label'}
                    deviceAccessGranted={props.permissionGranted}
                    noDevicesLabel={'Keine Kameras gefunden'}
                    defaultPlaceHolder={'Kamera auswählen'}
                    devices={props.cameras}
                    selectedDevice={props.selectedCamera}
                    defaultDevice={props.defaultCamera}
                    onSelectDevice={onSelectMicrophoneCb}
                    deviceAccessDeniedLabel={'Ihr Browser blockiert den Zugriff auf Ihre Kamera.'}
                />
            )}
        </>
    );

    const microphoneBlockedDropdown = (
        <DevicePermissionDropdown
            {...props.dropdownProps}
            isMobile={props.isMobile}
            constrain={{ video: true, audio: false }}
            onClick={props.onClickEnableDevicePermission}
        />
    );

    return (
        <DeviceSelectionContainer iconName={iconName}>
            {permissionGranted ? micGrantedDropdown : microphoneBlockedDropdown}
        </DeviceSelectionContainer>
    );
};
